import PropTypes from 'prop-types';
import React from 'react';
import TimelineContainer from 'common/timeline/containers/timeline-container';
import { useParams } from 'react-router';

const InstalledAtTimeline = ({ renderMenu, ...rest }) => {
  const params = useParams();
  return <>
    <TimelineContainer
      id={rest?.id}
      type='installedat'
      jumpToDate={
        params.filtervalue ? null : params.jumpToDateOrFilter
      }
      activeFilter={
        params.filtervalue && params.jumpToDateOrFilter
      }
      activeFilterValue={params.filtervalue}
      canCreateTicket={true}
      canCreateOrder={false}
      renderMenu={renderMenu}
      {...rest}
    />
  </>;
};

InstalledAtTimeline.propTypes = {
  jumpToDate: PropTypes.string,
  renderMenu: PropTypes.func.isRequired,
};

export default InstalledAtTimeline;
